module.exports = __webpack_public_path__ + "img/cabae13bc793465a86226dd98cf88cc1_mergeImage.67cad5a4.png";